import React from 'react';

interface VADRecordingIndicatorProps {
  isVADEnabled: boolean;
  waveBarRefs: React.RefObject<any>[];
  hideBorder?: boolean;
}

export const VADRecordingIndicator: React.FC<VADRecordingIndicatorProps> = ({
  isVADEnabled,
  waveBarRefs,
  hideBorder = false,
}) => {
  if (!isVADEnabled) return null;


  return (
    <>
      {/* Red border gradient around screen with fade to center */}
      {!hideBorder && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            zIndex: 9999,
            boxShadow: `
              inset 0 0 0 4px rgba(255, 68, 68, 0.8),
              inset 0 0 20px 8px rgba(255, 68, 68, 0.6),
              inset 0 0 40px 16px rgba(255, 68, 68, 0.4),
              inset 0 0 60px 24px rgba(255, 68, 68, 0.2),
              inset 0 0 80px 32px rgba(255, 68, 68, 0.1)
            `,
            animation: 'borderPulse 2s ease-in-out infinite',
          }}
        />
      )}

      {/* CSS Keyframes */}
      <style>{`
        @keyframes borderPulse {
          0%, 100% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>

    </>
  );
};
